export const initialState = { uploads: [] }

const patch = (state, key, fields) => ({
  ...state,
  uploads: state.uploads.map(u => (u.key === key ? { ...u, ...fields } : u)),
})

export function gisUploadReducer(state, action) {
  switch (action.type) {
    case 'ADD':
      return { ...state, uploads: [action.upload, ...state.uploads] }
    case 'SET_IDS':
      return patch(state, action.key, {
        serverId: action.serverId,
        uploadId: action.uploadId,
      })
    case 'S3':
      return patch(state, action.key, { s3Pct: action.pct })
    case 'DJANGO':
      return patch(state, action.key, {
        djangoPct:
          action.pct == null
            ? state.uploads.find(u => u.key === action.key)?.djangoPct ?? 0
            : action.pct,
        ...(action.message ? { message: action.message } : {}),
      })
    case 'PHASE':
      return patch(state, action.key, {
        phase: action.phase,
        ...(action.message ? { message: action.message } : {}),
      })
    case 'ERROR':
      return patch(state, action.key, { phase: 'error', error: action.error })
    case 'REMOVE':
      return {
        ...state,
        uploads: state.uploads.filter(u => u.key !== action.key),
      }
    default:
      return state
  }
}

export const selectGlobalPct = u =>
  Math.round((u.s3Pct || 0) * 0.5 + (u.djangoPct || 0) * 0.5)

export const uploadKind = typeOrUpload => {
  const type =
    typeof typeOrUpload === 'string' ? typeOrUpload : typeOrUpload.type
  // Test positif par nature (cf lot 11, panneau) : un `else` générique aurait
  // étiqueté un import 3D 'raster', faute d'existence de la troisième valeur.
  if (type === 'vector') return 'vector'
  if (type === 'model3d') return 'model3d'
  return 'raster'
}

export function parseProgressPayload(payload) {
  const [kind, rawId] =
    payload.layer_id != null
      ? ['vector', payload.layer_id]
      : payload.model3d_id != null
        ? ['model3d', payload.model3d_id]
        : ['raster', payload.raster_id]
  return {
    kind,
    serverId: Number(rawId),
    status: payload.status,
    djangoPct:
      payload.progress_pct == null ? null : Number(payload.progress_pct),
    message: payload.message || '',
  }
}

export function matchUploadKey(uploads, { kind, serverId }) {
  const found = uploads.find(
    u => u.serverId === serverId && uploadKind(u) === kind,
  )
  return found ? found.key : null
}
